<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="bg_white radius8 bs class_details_header">
				<div class="class_details_header_top flex">
					<div class="class_details_header_top_l f30px cl_dark">{{data.class_name}}</div>
					<div class="class_details_header_top_r" v-if="type == 'normal'">
						<el-popover placement="bottom-end" width="120" trigger="click">
						  <div class="class_details_header_select">
								<div class="flex cur f16px cl_dark mat10" v-for="(item,index) in data.duty_data" :key="index">
									<span>{{item.subjectName}}</span>
									<i @click="resign(index)">辞去</i>
								</div>
							</div>
						  <el-button slot="reference" class="cl_violet f14px"><span class="mar5">所有职务</span><img src="../../../static/select_violet_btm.png" /></el-button>
						</el-popover>
					</div>
					<div class="class_details_header_top_r" v-else>
						<button class="class_title_set cl_violet mar10" @click="dissolution">解散班级</button>
					</div>
				</div>
				<div class="class_details_header_btm tc" v-if="type == 'normal'">
					<div class="class_details_header_list radius8" v-for="(item,index) in data.teacher_data" :key="index">
						<h3 class="f16px cl_gray">{{item.duty_name}}</h3>
						<p class="f20px mat5">{{item.real_name}}</p>
					</div>
				</div>
			</div>
			<div class="bg_white radius8 bs class_details_cont mat30">
				<div class="class_screen">
					<div class="class_screen_l flex">
						<input type="text" placeholder="输入学生名称搜索" v-model="className" class="class_screen_input radius20" />
						<button class="class_screen_submit radius20 cl_white" @click="search">搜索</button>
					</div>
					<div class="class_screen_r flex">
						<div class="famous_screen_list flex">
							<span class="cl_gray f18px">排序：</span>
							<el-select v-model="rankValue.id" placeholder="全部" @change="rankSelect">
								<el-option v-for="(item,index) in rank":key="index" :label="item.name":value="item.id"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="f18px cl_dark mat30" v-if="list.length > 0">共&nbsp;<span class="cl_yel">{{total}}</span>&nbsp;个学生</div>
				<div class="student_cont mat20" v-if="list.length > 0">
					<div class="student_list radius8 bs" v-for="(item,index) in list" :key="index">
						<div class="student_list_top">
							<el-popover placement="bottom" width="80" trigger="click">
							  <div class="student_list_top_hide tc f16px cl_dark">
									<p class="cur" @click="deleteStudent(index)">删除学生</p>
									<p class="cur mat10" @click="editStudent(index)">修改姓名</p>
								</div>
							  <el-button slot="reference"><img src="../../../static/icon_spot.png" /></el-button>
							</el-popover>
						</div>
						<div class="student_list_info tc f16px">
							<img :src="item.avatar" class="radius" />
							<p class="mat5">{{item.real_name ? item.real_name : "未填写"}}</p>
							<p class="cl_violet mat5">{{item.phone}}</p>
						</div>
						<div class="student_list_item flex cl_dark mat10">
							<p>学科答题</p>
							<p><span class="cl_yel">{{item.topic_num}}</span> 道</p>
						</div>
						<div class="student_list_item flex cl_dark mat10">
							<p>答题正确率</p>
							<p><span class="cl_yel">{{item.accuracy}}</span>%</p>
						</div>
						<div class="student_list_item flex cl_dark mat10">
							<p>看课次数</p>
							<p><span class="cl_yel">{{item.course_num}}</span> 次</p>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next" 
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>暂无学生，您可以督促学生加入班级</p>
				</div>
			</div>
		</div>
		
		<!-- 修改姓名 -->
		<el-dialog title="提示" :visible.sync="editShow" width="30%">
		  <div class="f16px">
				<p class="cl_dark"><span class="cl_red">*</span>修改学生姓名为</p>
				<input type="text" maxlength="10" v-model="editName" class="f16px block mat10 edit_name_input" />
			</div>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="editShow = false">取 消</el-button>
		    <el-button type="primary" @click="editConfirm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_details',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				id: "",
				type: "",
				data: {},
				className: "",
				rank: [
					{
						id: 0,
						name: "学科答题数从高到低",
						orders: "u.topic_num",
						sorts: "asc",
					},{
						id: 1,
						name: "学科答题数从低到高",
						orders: "u.topic_num",
						sorts: "desc",
					},
				],
				rankValue: {
					id: 0,
				},
				orders: "u.topic_num",
				sorts: "asc",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 15, //每页数量
				total: 0, //总页数
				editShow: false, //修改姓名
				editName: "",
				editId: "",
				subjectId: "",
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
		},
		mounted() {
			this.getDuty();
			this.getDetails();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//职务
			getDuty () {
				this.$get("/api/teacher/get_class_teacher_duty_data",{
					token: localStorage.getItem("token"),
					class_id: this.id,
				})
				.then(res => {
					this.data = res.data;
				});
			},
			//学生列表
			getDetails () {
				this.$get("/api/teacher/get_class_student_list",{
					token: localStorage.getItem("token"),
					class_id: this.id,
					name: this.className,
					page: this.currentPage,
					limit: this.pageSize,
					orders: this.orders,
					sorts: this.sorts,
				})
				.then(res => {
					this.list = [];
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			rankSelect (e) {
				this.orders = this.rank[e].orders;
				this.sorts = this.rank[e].sorts;
				this.currentPage = 1;
				this.getDetails();
			},
			search () {
				if (this.className == "") {
					this.$message({
						type: 'warning',
						message: '搜索不能为空',
						duration: 1500,
					});
					return false
				}
				this.currentPage = 1;
				this.getDetails();
			},
			//辞去职务
			resign (e) {
				this.subjectId = this.data.duty_data[e].subjectId;
				this.$messageBox.confirm('确定要辞去该职务吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_teacher_resign",{
						token: localStorage.getItem("token"),
						class_id: this.id,
						subject_id: this.subjectId,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						if (this.data.duty_data > 1) {
							this.currentPage = 1;
							this.getDuty();
						} else {
							setTimeout(() => {
								this.$router.go(-1);
							}, 1500);
						}
					});
				}).catch(() => {
					
				});
			},
			//删除学生
			deleteStudent (e) {
				const h = this.$createElement;
				this.$messageBox({
					title: '提示',
					message: h('p', null, [
						h('p', { style: 'font-size: 16px' }, '确定要把学生移除出班级吗？'),
						h('p', { style: 'color: #999' }, '移除后将在下一次布置作业时生效，已布置作业中仍会出现该同学。')
					]),
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(action => {
					this.editId = this.list[e].id;
					this.$get("/api/teacher/post_class_student_del",{
						token: localStorage.getItem("token"),
						class_id: this.id,
						student_id: this.editId,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.currentPage = 1;
						this.getDetails();
					});
				}).catch(() => {
					
				});
			},
			//修改姓名
			editStudent (e) {
				this.editShow = true;
				this.editId = this.list[e].id;
				this.editName = "";
			},
			editConfirm () {
				this.$get("/api/teacher/post_edit_student_name",{
					token: localStorage.getItem("token"),
					class_id: this.id,
					student_id: this.editId,
					name: this.editName,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.editShow = false;
					this.currentPage = 1;
					this.getDetails();
				});
			},
			//解散班级
			dissolution () {
				this.$messageBox.confirm('确定要解散该班级吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_dissolve_class",{
						token: localStorage.getItem("token"),
						class_id: this.id,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						setTimeout(() => {
							this.$router.go(-1);
						}, 1500);
					});
				}).catch(() => {
					
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getDetails();
			},
		},
	}
</script>

<style>
</style>
